<template>
  <header class="legacy-header">
    <a href="/" class="brand"><img src="../assets/img/site-logo.jpg" alt="Universtage"></a>
    <button class="menu-toggle" type="button" :aria-expanded="String(menuOpen)" aria-controls="site-navigation" @click="menuOpen = !menuOpen">{{ menuOpen ? 'Close' : 'Menu' }} <i class="fa fa-bars" aria-hidden="true"></i></button>
    <nav id="site-navigation" :class="{ 'is-open': menuOpen }" aria-label="Main navigation">
      <a href="/#explore-jobs">Explore Jobs</a>
      <router-link :to="{name: 'search'}">All Performers</router-link>
      <template v-if="isLogin">
        <router-link :to="{name: 'messages'}">Messages</router-link>
        <details class="account-menu"><summary :class="{'active-account': ['profile', 'password'].includes($route.name)}">My account</summary><div>
          <router-link :to="{name: 'profile', params: {id: getUserProfile.id}}">My Profile</router-link>
          <button type="button" @click="logOut">Log Out</button>
        </div></details>
      </template>
      <template v-else>
        <router-link :to="{name: 'login'}">Log In</router-link>
        <router-link :to="{name: 'register'}" class="signup">Sign Up</router-link>
      </template>
    </nav>
  </header>
</template>
<script>
import { mapGetters } from 'vuex';
import { AUTH_LOGOUT } from '../store/actions/userConst';
export default {
  data: () => ({ menuOpen: false }),
  computed: { ...mapGetters(['isLogin', 'getUserProfile']) },
  watch: { '$route'() { this.menuOpen = false; } },
  methods: { logOut() { this.$store.dispatch(AUTH_LOGOUT).then(() => window.location.assign('/')); } }
};
</script>
<style scoped>
.legacy-header { background: #101014; color: #fff; display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 8px 4%; border-bottom: 2px solid #a82d38; position: relative; z-index: 30; }
.brand { display: block; line-height: 0; }
.brand img { width: 112px; height: auto; }
nav { display: flex; align-items: center; gap: 26px; }
nav a, summary, nav button { color: #fff; font: inherit; font-size: 14px; text-decoration: none; text-transform: none; }
nav > a { padding: 12px 0; border-bottom: 2px solid transparent; }
nav > .router-link-active { border-bottom-color: #a82d38; }
nav a:hover, summary:hover { color: #efc3c7; }
.menu-toggle { display: none; }
.active-account { border-bottom: 2px solid #a82d38; }
summary { cursor: pointer; padding: 12px 0; }
.account-menu { position: relative; }
.account-menu > div { position: absolute; right: 0; min-width: 160px; padding: 8px; background: #101014; border: 1px solid #575057; border-radius: 6px; }
.account-menu a, .account-menu button { display: block; padding: 10px; width: 100%; text-align: left; background: transparent; border: 0; cursor: pointer; }
.signup { border: 1px solid #a82d38; border-radius: 6px; padding: 8px 14px; }
@media(max-width: 767px) {
  .legacy-header { flex-wrap: wrap; gap: 0; padding: 8px 16px; }
  .brand img { width: 90px; }
  .menu-toggle { display: block; color: white; background: transparent; border: 1px solid #67565a; border-radius: 6px; padding: 8px 12px; }
  nav { display: none; width: 100%; padding-top: 12px; align-items: stretch; gap: 0; flex-direction: column; }
  nav.is-open { display: flex; }
  nav > a { padding: 12px; }
  .account-menu { padding: 0 12px; }
  .account-menu > div { position: static; border: 0; }
}
</style>
